import * as React from 'react';
import { Integrations } from './integrations';

export const Main = () => {
  return <Integrations />;
};
